import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';

const TestPrintContract: React.FC = () => {
  const navigate = useNavigate();

  const testUrls = [
    '/test-print-contract',
    '/members/test-id/print-contract',
    '/members/684f89052190db07570a30ed',
    '/members/684f89052190db07570a30ed?debug=true',
    '/members/684f8afd7cb3474893541b9a',
    '/members/684f8afd7cb3474893541b9a?debug=true'
  ];

  const handleDebugMembers = async () => {
    try {
      const response = await apiService.get('/api/members/debug/list-members');
      console.log('Debug members response:', response.data);
      alert(`Found ${response.data.members?.length || 0} members. Check console for details.`);
    } catch (error: any) {
      console.error('Debug members error:', error);
      alert('Error fetching debug members: ' + error.message);
    }
  };

  const handleDebugSpecificMember = async () => {
    const memberId = prompt('Enter member ID to debug:');
    if (!memberId) return;
    
    try {
      const response = await apiService.get(`/api/members/debug/check-member/${memberId}`);
      console.log('Debug specific member response:', response.data);
      alert(`Member check result: ${response.data.message}. Check console for details.`);
    } catch (error: any) {
      console.error('Debug specific member error:', error);
      alert(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Print Contract Test Page
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        This is a test page to verify that print contract functionality is working.
      </Alert>

      <Typography variant="h6" gutterBottom>
        Test URLs:
      </Typography>

      {testUrls.map((url, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              console.log(`Testing navigation to: ${url}`);
              alert(`Testing navigation to: ${url}`);
              try {
                navigate(url);
              } catch (error) {
                console.error('Navigation error:', error);
                alert(`Navigation failed: ${error}`);
              }
            }}
          >
            Test: {url}
          </Button>
        </Box>
      ))}

      <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
        Quick Actions:
      </Typography>
      
      <Button
        variant="contained"
        sx={{ mr: 2 }}
        onClick={() => navigate('/members')}
      >
        Go to Members List
      </Button>
      
      <Button
        variant="outlined"
        sx={{ mr: 2 }}
        onClick={() => navigate('/dashboard')}
      >
        Go to Dashboard
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        sx={{ mr: 2 }}
        onClick={handleDebugMembers}
      >
        Debug: List Members
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        sx={{ mr: 2 }}
        onClick={handleDebugSpecificMember}
      >
        Debug: Check Specific Member
      </Button>

      <Button
        variant="outlined"
        color="warning"
        sx={{ mr: 2 }}
        onClick={() => navigate('/members/684f89052190db07570a30ed?debug=true')}
      >
        Test Problematic Member (Debug Mode)
      </Button>

      <Button
        variant="contained"
        color="success"
        sx={{ mr: 2 }}
        onClick={() => navigate('/members/684f89052190db07570a30ed/print-contract')}
      >
        Test Print Contract
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={() => window.open('/members/684f89052190db07570a30ed/print-contract', '_blank')}
      >
        Open Print Contract (New Tab)
      </Button>
    </Box>
  );
};

export default TestPrintContract;
